// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GG4zD2vQX40Fsc__Ue2d {
    padding-bottom: 16px;
}

.viRZJXQcK6uvxEg29HEs {
    width: 30%;
    min-width: 425px;
    box-sizing: border-box;
}

.f6x4DrEhdS6UqKKW8c9H {
    padding: 32px 16px 16px;
    box-sizing: border-box;
    border-bottom: 1px solid #E5E5E5;
}

.ROIs9hRqvwOezO68fUYR {
    font-size: 20px;
    margin: 0;
}

.Hqehioj7GTyON7SHwfWF {
    font-size: 16px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin: 8px 0 0;
}

.Szje9xRkmaR8NhUOXc2Q {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    column-gap: 32px;
    row-gap: 12px;
    margin-top: 16px;
}

.ihqJxXIyiMZgipbE7q5a {
    padding: 16px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.ihqJxXIyiMZgipbE7q5a img {
    width: 50%;
    max-width: 320px;
    opacity: 0.5;
}

.ihqJxXIyiMZgipbE7q5a p {
    font-weight: 500;
    font-size: 18px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    text-align: center;
}

@media screen and (max-width: 768px) {
    .viRZJXQcK6uvxEg29HEs {
        padding: 0 32px 32px;
        box-sizing: border-box;
    }

    .GG4zD2vQX40Fsc__Ue2d {
        background-color: white;
        border-radius: 5px;
    }
}

@media screen and (max-width: 425px) {
    .viRZJXQcK6uvxEg29HEs {
        min-width: unset;
        padding: 0 16px 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWallet.module.css"],"names":[],"mappings":"AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mDAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI;QACI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,oBAAoB;IACxB;AACJ","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-text-subtle, color-error, color-gray-light from colors;\n\n.container {\n    padding-bottom: 16px;\n}\n\n.wallet {\n    width: 30%;\n    min-width: 425px;\n    box-sizing: border-box;\n}\n\n.header {\n    padding: 32px 16px 16px;\n    box-sizing: border-box;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.title {\n    font-size: 20px;\n    margin: 0;\n}\n\n.description {\n    font-size: 16px;\n    color: color-text-subtle;\n    margin: 8px 0 0;\n}\n\n.balance {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    column-gap: 32px;\n    row-gap: 12px;\n    margin-top: 16px;\n}\n\n.empty {\n    padding: 16px;\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.empty img {\n    width: 50%;\n    max-width: 320px;\n    opacity: 0.5;\n}\n\n.empty p {\n    font-weight: 500;\n    font-size: 18px;\n    color: color-text-subtle;\n    text-align: center;\n}\n\n@media screen and (max-width: 768px) {\n    .wallet {\n        padding: 0 32px 32px;\n        box-sizing: border-box;\n    }\n\n    .container {\n        background-color: white;\n        border-radius: 5px;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    .wallet {\n        min-width: unset;\n        padding: 0 16px 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"container": `GG4zD2vQX40Fsc__Ue2d`,
	"wallet": `viRZJXQcK6uvxEg29HEs`,
	"header": `f6x4DrEhdS6UqKKW8c9H`,
	"title": `ROIs9hRqvwOezO68fUYR`,
	"description": `Hqehioj7GTyON7SHwfWF`,
	"balance": `Szje9xRkmaR8NhUOXc2Q`,
	"empty": `ihqJxXIyiMZgipbE7q5a`
};
export default ___CSS_LOADER_EXPORT___;
